export const ADMIN_LAYOUT_ROUTE = "/admin";
export const AGENCY_LAYOUT_ROUTE = "/agency";
export const SIGNIN_ROUTE = "/signin";
export const INITIAL_LAYOUT = "/";
export const SIGNIN_AUTH_ROUTE="/signinauth"

// Admin Panell
export const ADMIN_DASHBOARD_ROUTE = "/admin/dashboard";
export const ADMIN_AGENCY_ROUTE = "/admin/agency";
export const ADMIN_AGENCY_CREATE_ROUTE = "/admin/agency-create";
export const ADMIN_AGENCY_DETAILS = "/admin/agency-details";
export const ADMIN_CUSTOMER_DETAILS = "/admin/customer-details";
export const ADMIN_CUSTOMER_LICENSE = "/admin/customer-license";
export const ADMIN_LICENSE_DETAILS = "/admin/license-details";
export const ADMIN_EMPLOYEE_ROUTE = "/admin/employee";
export const ADMIN_EMPLOYEE_CREATE_ROUTE = "/admin/employee-create";
export const ADMIN_SETTINGS = "/admin/settings";
export const ADMIN_AGENCY_REPORT = "/admin/agencyreport";
export const ADMIN_PAYMENT_REPORT = "/admin/paymentreport";
export const ADMIN_AGENCY_TEMPLATES = "/admin/templates";
export const TEMPLATE_DETAILS = "/admin/templatedetails/:templateId";
export const TEMPLATE_FORM_DETAILS = "/admin/templateform";
export const ADMIN_AGENCY_UPDATE = "/admin/agency-update";
//agency Panel
export const AGENCY_DASHBOARD_ROUTE = "/agency/dashboard";
export const AGENCY_TEMPLATE_ROUTE = "/agency/template";
export const AGENCY_CREATE_TEMPLATE = "/agency/edit-template";
export const AGENCY_LICENSE_ROUTE = "/agency/license";
export const AGENCY_CUSTOMER_ROUTE = "/agency/customer";
export const AGENCY_CUSTOMER_DETAILS_ROUTE = "/agency/customer-details";
export const AGENCY_VIEW_LICENSE_ROUTE = "/agency/view-license";
export const AGENCY_EMPLOYEE_ROUTE = "/agency/employee";
export const AGENCY_SETTINGS = "/agency/settings";
export const AGENCY_KERNEL_LICENSE = "/agency/kernellicense";
export const AGENCY_TEMPLATE_FORM = "/agency/edit-templateform";
export const AGENCY_CREATE_FORM = "/agency/createform";
export const AGENCY_LICENSE_REPORT = "/agency/licensereport";
export const AGENCY_CUSTOMER_REPORT = "/agency/customerreport";
export const AGENCY_CUSTOMER_PAYMENT_REPORT = "/agency/customerpaymentreport";

//user panel
export const USER_SIGNIN = "/customer";
export const USER_DASHBOARD = "/customer-portal";
export const USER_NEW_LICENSE = "/user/new-license";
export const USER_CREATE_LICENSE = "/user/join-license";
export const USER_SIGNIN_UP = `/customer/:${"agencyUrl"}/signup`;
export const FORGET_PASSWORD = "/forgetpassword";
export const USER_FORGET_PASSWORD = `/customer/:${"agencyUrl"}/forgetpassword`;
// export const USER_PAYMENT = "/user/payment";
export const USER_PAYMENT =
  "/payment/dogLicenseId=:dogLicenseId&userId=:userId&ttId=:ttId";
export const USER_CHOOSE_PLAN = "/user/chooseplan";
export const USER_PREVIEW_PLAN = "/user/previewplan";
export const PAGE_NOT_FOUND_ROUTE = "*";
export const CUSTOMER_VIEW_LICENSE = "/customer/view-license";

export const PAYMENT_SUCCESS = "/agency/payment-success";
//Poc
export const GUEST_USER = "/agency/guestuser";
export const GUEST_DETAILS = "/agency/guest-details";
export const GUEST_NEW_LICENSE = "/agency/customer-license";
export const AGENCY_PAYMENT = "/agency/payment";
export const GUEST_USER_LICENSE = "/agency/guest-license";
export const GUEST_CHOOSE_PLAN = "/agency/chooseplan";
export const CARD_TYPE = "/agency/cardtype";
export const AGENCY_PLAN_SITE = "/agencyplan";